import styled from 'styled-components';

import { Button } from '@xing-com/crate-lebenslauf-button';
import { spaceL, spaceXXL } from '@xing-com/tokens';

export const StyledScrollWrapper = styled.div`
  overflow-y: auto;
  padding: 0 3px;
  margin: 0 -3px;
`;

export const StyledBackButton = styled(Button)`
  margin-top: ${spaceXXL};
  margin-right: ${spaceL};
`;
